import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Link, NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PayrollMenu from "./PayrollMenu";
import { formatDateInput } from "./PayRateAmountFields";

const ManagePayRates = (props) => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);

  useEffect(() => {
    document.title = "Manage Pay Rates";
    setIsUpdated(false);
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "Payroll/GetPayRatesList",
      headers: { "Content-Type": "application/json" },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setList(response.data.ListofRecords || []);
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType, isUpdated]);

  const deletePayRate = (ID) => {
    if (!window.confirm("Are you sure you want to delete this Pay Rate?")) return;
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: ID,
    };
    axios({
      method: "post",
      url: config.base_url + "Payroll/DeletePayRate",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          toast.success(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
          setIsUpdated(true);
        } else {
          toast.error(response.data.status_message || "Delete failed.", { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch(function () {
        toast.error("Network Error.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const renderRows = () => {
    if (list.length > 0) {
      return list.map((item, index) => (
        <tr key={item.ID || index}>
          <td>{item.ID}</td>
          <td>{item.Category ?? ""}</td>
          <td>{item.PayScale}</td>
          <td>{formatDateInput(item.EffectiveFrom) || "—"}</td>
          <td>{item.School_ID != null ? item.School_ID : "—"}</td>
          <td>{item.BasicPay}</td>
          <td>{item.MedicalAllowance}</td>
          <td>{item.ConveyanceAllowance}</td>
          <td>{item.SalaryPM}</td>
          <td>{item.Is_Active ? "Yes" : "No"}</td>
          <td>
            <ul className="inline-action" aria-labelledby="dropdownMenuButton1">
              <li>
                <NavLink to={"/Payroll/EditPayRate/" + item.ID} className="green">
                  <i className="ri-edit-line"></i>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/Payroll/ManagePayRateDetails?id=" + item.ID} className="blue">
                  <i className="ri-table-line"></i>
                </NavLink>
              </li>
              <li>
                <button type="button" onClick={() => deletePayRate(item.ID)} className="red">
                  <i className="ri-delete-bin-line"></i>
                </button>
              </li>
            </ul>
          </td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="9">
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <PayrollMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/PayRoll/PayRollDashboard">PayRoll</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Manage Pay Rates
                  </li>
                </ol>
              </nav>
              <div className="page-title">Manage Pay Rates</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link to="/Payroll/AddPayRate" className="button button-white button-icon">
                  Add Pay Rate
                  <i className="ri-add-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Category</th>
                    <th>Pay Scale</th>
                    <th>Effective from</th>
                    <th>School</th>
                    <th>Basic Pay</th>
                    <th>Medical Allowance</th>
                    <th>Conveyance Allowance</th>
                    <th>Salary PM</th>
                    <th>Active</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan="11">
                        <Spinner animation="border" role="status"></Spinner>
                      </td>
                    </tr>
                  ) : (
                    renderRows()
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManagePayRates;
